import './coverage-status.scss';

const CoverageStatus = ({ clientName, status }) => {
  return (
    <div className="coverage-status-container">
      <span className="client-name">{clientName}</span>{' '}
      <span
        className={`status ${
          status === 'Terminated' ? 'status-error' : 'status-other'
        }`}
      >
        ({status})
      </span>
    </div>
  );
};

export default CoverageStatus;
